import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import PurchaseOrderView from '../../components/Purchase/PurchaseOrderView';

const PurchaseOrderViewPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <PurchaseOrderView/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default PurchaseOrderViewPage;